import { render, staticRenderFns } from "./regimeDialog.vue?vue&type=template&id=94c0091c&scoped=true&"
import script from "./regimeDialog.vue?vue&type=script&lang=js&"
export * from "./regimeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c0091c",
  null
  
)

export default component.exports